export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "available_time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Available Time"])},
      "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NEW"])},
      "expired": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Expired"])}
    }
  })
}
